import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import PageLayout from '../../components/PageLayout.vue';
import TowCodeProcessor from '../../components/TowCode.vue';
export default {
  __name: 'TowCodePage',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PageLayout, {
        title: "二维码生成工具",
        "current-page": "towcode"
      }, {
        default: _withCtx(() => [_createVNode(TowCodeProcessor)]),
        _: 1
      });
    };
  }
};